export { DocsViewerContent } from './DocsViewerContent';

import { Entity } from '@backstage/catalog-model';

export const isDocsViewerAvailable = (entity: Entity) =>
  Boolean(entity.metadata.annotations?.['github.com/project-slug']);
